
export function formatPrice(price) {
    if (price < 1000) return price.toString();
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
export const formattedPrice = (price, actual_price, sale) => {
    return (
        <span>
            {price !== null && sale !== null && sale > 0 && (
                <span style={{ textDecoration: "line-through" }}>{formatPrice(price)} &#8381;</span>
            )}
            {sale !== null && sale > 0 && (
                <span style={{ color: "red", marginLeft: "8px", marginRight: actual_price !== null ? "8px" : "" }}>{sale}%</span>
            )}
            {actual_price !== null && (
                <span>{formatPrice(actual_price)} &#8381;</span>
            )}
        </span>
    );
};

export const calculateSaleFromCartItems = (items, promo = null) => {
    const totalPrice = items.reduce((sum, item) => {
        return item.availability === 0 ? sum : sum + item.product.price * item.count;
    }, 0);

    const actualPrice = items.reduce((sum, item) => {
        return item.availability === 0 ? sum : sum + item.product.actual_price * item.count;
    }, 0);

    let discount = totalPrice - actualPrice;

    if (promo && promo.type === 'discount') {
        const promoDiscount = (actualPrice * promo.discount) / 100;
        discount += promoDiscount;
    }
    if (discount > 0 ){
        return formatPrice(Math.floor(discount));
    }

    return null
};
export const calculateTotalFromCartItems = (items, promo = null) => {
    const totalPrice = items.reduce((sum, item) => {
        return item.availability === 0 ? sum : sum + item.product.price * item.count;
    }, 0);

    return formatPrice(totalPrice)
};
export const calculateFinalFromCartItems = (items, promo = null) => {
    let actualPrice = items.reduce((sum, item) => {
        return item.availability === 0 ? sum : sum + item.product.actual_price * item.count;
    }, 0);

    if (promo && promo.type === 'discount') {
        actualPrice -= actualPrice * promo.discount / 100;
    }

    return formatPrice(Math.ceil(actualPrice))
};

export const plural = (n, forms) => {
    const number = Math.abs(n);

    // Для чисел 11-14 всегда берем множественную форму (forms[2])
    if (number % 100 >= 11 && number % 100 <= 14) {
        return forms[2];
    }
    // Выбираем форму по последней цифре
    switch (number % 10) {
        case 1: return forms[0]; // singular
        case 2:
        case 3:
        case 4: return forms[1]; // paucal
        default: return forms[2]; // plural
    }
}